// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Longitude of the GPS coordinate of the search area.\n\nThe search will cover the whole of France if not specified.\n\nThis field must be mandatory when used with the longitude field.\n"
export default markdown
